"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Auth = void 0;
var Auth;
(function (Auth) {
    Auth.loginLinkSent = 'auth:login-link-email-sent';
    var emailEvents = new Set([Auth.loginLinkSent]);
    function isEmailEvent(message) {
        return loginResults.has(message);
    }
    Auth.isEmailEvent = isEmailEvent;
    Auth.loginSucceeded = 'auth_login:succeeded';
    Auth.highlightsLoginSucceeded = 'auth_login:highlights-succeeded';
    Auth.loginWithLinkSucceeded = 'auth_login:login-with-link-succeeded';
    var loginResults = new Set([Auth.loginSucceeded, Auth.loginWithLinkSucceeded, Auth.highlightsLoginSucceeded]);
    function isLoginResult(message) {
        return loginResults.has(message);
    }
    Auth.isLoginResult = isLoginResult;
    Auth.logoutSucceeded = 'auth:logout-succeeded';
    Auth.logoutFailed = 'auth:logout-failed';
    var logoutResults = new Set([Auth.logoutSucceeded, Auth.logoutFailed]);
    function isLogoutResult(message) {
        return logoutResults.has(message);
    }
    Auth.isLogoutResult = isLogoutResult;
    Auth.abortLogin = 'auth:abort-login';
    var abortLoginResults = new Set([Auth.abortLogin]);
    function isAbortLoginResult(message) {
        return abortLoginResults.has(message);
    }
    Auth.isAbortLoginResult = isAbortLoginResult;
    Auth.setAcquisitionParamsSucceeded = 'auth:set-acquisition-params-succeeded';
    Auth.setAcquisitionParamsFailed = 'auth:set-acquisition-params-failed';
    var setAcquisitionParamsResults = new Set([Auth.setAcquisitionParamsSucceeded, Auth.setAcquisitionParamsFailed]);
    function isSetAcquisitionParamsResult(message) {
        return setAcquisitionParamsResults.has(message);
    }
    Auth.isSetAcquisitionParamsResult = isSetAcquisitionParamsResult;
})(Auth = exports.Auth || (exports.Auth = {}));
//# sourceMappingURL=auth.js.map